export default __webpack_public_path__ + "static/media/glimmer.e051f062.png";